module.exports = __webpack_public_path__ + "img/06n.ed5432a7.png";